import { Button } from "@/components/ui/button.js";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu.js";
import { ArrowUpDown } from "lucide-react";

export interface SortOption<T extends string = string> {
  value: T;
  label: string;
}

interface SortDropdownProps<T extends string = string> {
  options: readonly SortOption<T>[];
  value: T;
  onChange: (value: T) => void;
  /** Alignment of the dropdown content. Defaults to "end". */
  align?: "start" | "center" | "end";
}

export function SortDropdown<T extends string>({
  options,
  value,
  onChange,
  align = "end",
}: SortDropdownProps<T>) {
  const activeLabel = options.find((o) => o.value === value)?.label ?? "Sort";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-9 gap-1.5 rounded-sm px-3 text-sm text-foreground ml-auto"
        >
          <ArrowUpDown className="size-3.5" aria-hidden="true" />
          {activeLabel}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align}>
        {options.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => onChange(option.value)}
            className={value === option.value ? "bg-accent font-medium" : ""}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
